<template>
  <v-row justify="center">
    <v-col lg="4">
      <v-dialog
        v-model="dialogVisible"
        width="clamp(350px, 50%, 50%)"
        persistent
      >
        <v-card>
          <v-card-title>
            <v-chip color="primary">
              Загрузка файла
            </v-chip>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-file-input
              accept="text/plain, .csv"
              hint="Выбрать файл в формате .csv"
              label="Выбрать файл"
              show-size
              @change="selectFile"
            />
            <v-alert
              v-if="message"
              border="left"
              color="red"
              outlined
            >
              {{ message }}
            </v-alert>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-row
              align-content="space-between"
              justify="space-around"
            >
              <v-btn
                color="error"
                outlined
                small
                @click="closeDialog"
              >
                Закрыть
              </v-btn>
              <v-btn
                color="success"
                dark
                outlined
                small
                @click="upload"
              >
                <v-icon
                  dark
                  left
                >
                  mdi-cloud-upload
                </v-icon>
                Загрузить
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { Userprofile } from "@/views/loyalty/shared/services/userprofile-service"

export default {
  name: "UserProfileUploadDialog",
  props: ["customerId", "customerNumber", "dialogVisible"],
  data: () => ({
    currentFile: undefined,
    progress: 0,
    message: "",
    fileInfos: [],
      userProfileService: undefined
  }),
  mounted () {
      this.userProfileService = new Userprofile()
  },
  methods: {
    closeDialog () {
        this.currentFile = ""
      this.message = ""
      this.$emit("close")
    },
    selectFile (file) {
      this.progress = 0
      this.currentFile = file
      this.message = ""
    },
    async upload () {
      if (!this.currentFile) {
        this.message = "Выберите файл!"
        return
      }
      this.message = ""
      await this.userProfileService.uploadFile(this.customerId, this.customerNumber, this.currentFile)
        this.progress = 100
    },
  }
}
</script>

<style scoped></style>
